import { deepMerge } from 'js/utils/Utils'
import { PlaneGeometry } from 'three'

import SlideshowAPlaneMesh from 'js/webgl/customMeshes/SlideshowAPlaneMesh'
import SlideshowBPlaneMesh from 'js/webgl/customMeshes/SlideshowBPlaneMesh'
import BgColorPlaneMesh from 'js/webgl/customMeshes/BgColorPlaneMesh'
import ListThumbAPlaneMesh from 'js/webgl/customMeshes/ListThumbAPlaneMesh'
import BannerAPlaneMesh from 'js/webgl/customMeshes/BannerAPlaneMesh'

const defaults = {
  instanceName: 'companyWebgl',
  $names: {
    bg: '[data-gl-item="bg"]',
    slideshowA: '[data-gl-item="slideshow-a"]',
    slideshowB: '[data-gl-item="slideshow-b"]',
    listThumbA: '[data-gl-item="list-thumb-a"]',
    bannerA: '[data-gl-item="banner-a"]',
  },
  dataNames: {},
}

export default class CompanyWebgl {
  $contentRoot = document
  $bgs = []
  $slideshowAs = []
  $slideshowBs = []
  $listThumbAs = []
  $bannerAs = []
  meshesItems = []

  bgMeshes = []
  slideshowAMeshes = []
  slideshowBMeshes = []
  listThumbAMeshes = []
  bannerAMeshes = []
  originalPlaneGeometry = null

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this._setMeshes()
    this._addEventListeners()
    this._addGUI()
  }

  destroy() {
    this._removeGUI()
    this._removeEventListeners()
    this._clearMesh()
  }

  _set$() {
    this.$bgs = this.$contentRoot.querySelectorAll(this.$names.bg)
    this.$slideshowAs = this.$contentRoot.querySelectorAll(this.$names.slideshowA)
    this.$slideshowBs = this.$contentRoot.querySelectorAll(this.$names.slideshowB)
    this.$listThumbAs = this.$contentRoot.querySelectorAll(this.$names.listThumbA)
    this.$bannerAs = this.$contentRoot.querySelectorAll(this.$names.bannerA)
  }

  _setMeshes() {
    this.meshesItems = []
    this.originalPlaneGeometry = new PlaneGeometry(1, 1, 1, 1)

    this.bgMeshes = []
    this.$bgs.forEach(($bg, i) => {
      this.bgMeshes[i] = new BgColorPlaneMesh({
        webgl: this,
        $target: $bg,
        geometry: this.originalPlaneGeometry,
        instanceName: `companyWebgl-bg-${i}`,
        index: i,
      })
    })

    this.slideshowAMeshes = []
    this.$slideshowAs.forEach(($slideshowA, i) => {
      this.slideshowAMeshes[i] = new SlideshowAPlaneMesh({
        webgl: this,
        $target: $slideshowA,
        geometry: this.originalPlaneGeometry,
        instanceName: `companyWebgl-slideshowA-${i}`,
        index: i,
      })
    })

    this.slideshowBMeshes = []
    this.$slideshowBs.forEach(($slideshowB, i) => {
      this.slideshowBMeshes[i] = new SlideshowBPlaneMesh({
        webgl: this,
        $target: $slideshowB,
        geometry: this.originalPlaneGeometry,
        instanceName: `companyWebgl-slideshowB-${i}`,
        index: i,
      })
    })

    this.listThumbAMeshes = []
    this.$listThumbAs.forEach(($listThumbA, i) => {
      this.listThumbAMeshes[i] = new ListThumbAPlaneMesh({
        webgl: this,
        $target: $listThumbA,
        geometry: this.originalPlaneGeometry,
        instanceName: `companyWebgl-listThumbA-${i}`,
        index: i,
      })
    })

    this.bannerAMeshes = []
    this.$bannerAs.forEach(($bannerA, i) => {
      this.bannerAMeshes[i] = new BannerAPlaneMesh({
        webgl: this,
        $target: $bannerA,
        geometry: this.originalPlaneGeometry,
        instanceName: `companyWebgl-bannerA-${i}`,
        index: i,
      })
    })

    this.meshesItems.push(this.bgMeshes)
    this.meshesItems.push(this.slideshowAMeshes)
    this.meshesItems.push(this.slideshowBMeshes)
    this.meshesItems.push(this.listThumbAMeshes)
    this.meshesItems.push(this.bannerAMeshes)

    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.init()
      })
    })

    if (this.originalPlaneGeometry) {
      this.originalPlaneGeometry.dispose()
      this.originalPlaneGeometry = null
    }
  }

  _clearMesh() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.destroy()
        mesh = null
      })
    })
    this.meshesItems = []
  }

  _addEventListeners() {}

  _removeEventListeners() {}

  fvAnimation() {
    // this.bgXLMeshes[0]?.fvAnimation()
    if (this.slideshowBMeshes[0]) {
      this.slideshowBMeshes[0]?.fvAnimation()
    }
  }

  onResize() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.onResize()
      })
    })
  }

  onRaf() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.onRaf()
      })
    })
  }

  _addGUI() {
    // const meshes = []
    // meshes.forEach((mesh) => {
    //   if (mesh && mesh._addGUI) {
    //     mesh._addGUI()
    //   }
    // })
  }

  _removeGUI() {
    // this.meshesItems.forEach((meshesItem) => {
    //   meshesItem.forEach((mesh) => {
    //     mesh._removeGUI()
    //   })
    // })
  }
}